<template>
  <v-tooltip
    :value="show"
    :position-x="positionX"
    :position-y="positionY"
    top
  >
    <p v-for="line in text" :style="{ color }">
      {{ line }}
    </p>
  </v-tooltip>
</template>

<script>
export default {
  name: 'GraphTooltip',
  props: {
    tooltipModel: Object,
    elQuery: String,
    customTextFormat: Function,
  },

  data: () => ({
    show: false,
    text: 'test here',
    positionX: 0,
    positionY: 0,
    color: 'black',
  }),

  watch: {
    tooltipModel () {
      this.updateTooltip()
    },
  },

  mounted () {
    this.updateTooltip()
  },

  methods: {
    updateTooltip () {
      const chartRect = document.querySelector(this.elQuery).getBoundingClientRect()
      const { body, labelColors, opacity, caretX, caretY } = this.tooltipModel

      if (body) {
        this.text = this.customTextFormat
          ? this.customTextFormat(body[0].lines[0])
          : body[0].lines[0]
      } else {
        this.text = ''
      }

      if (typeof this.text === 'string') this.text = [this.text]

      if (labelColors) {
        this.color = labelColors[0].backgroundColor
      }

      this.positionX = chartRect.left + caretX
      this.positionY = chartRect.top + caretY

      this.show = !!opacity
    },

  },
}
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  background-color: white !important;
  border: $borderLight;
  padding: 10px;

  p { margin: 0; }
}
</style>
